// extracted by mini-css-extract-plugin
export default {"criteriaField":"criteria_criteriaField__RE+kO"};